import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CourseCard } from "components/learner/CourseCard";
import { Button } from "components/ui/button";
import { MyTrainingSummary } from "hooks/useMyTrainingSummary";
import { training } from "services/api";

export const CoursePreviews = () => {
  const [data, setData] = useState<MyTrainingSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const requestId = useRef(0);
  const load = useCallback(async () => {
    const id = ++requestId.current;
    setLoading(true);
    try {
      // Use lightweight library cards; do not preload every module image.
      const result = await training.summary({ view: "library" }) as MyTrainingSummary;
      if (id !== requestId.current) return;
      setData(result);
      setError(false);
    } catch {
      if (id === requestId.current) setError(true);
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }, []);
  useEffect(() => {
    void load();
    return () => { requestId.current += 1; };
  }, [load]);

  const courses = data?.assigned_courses?.slice(0, 3) ?? [];
  return (
    <section className="home-courses" aria-labelledby="home-courses-heading">
      <div className="home-section-heading">
        <h2 id="home-courses-heading">Your courses</h2>
        <Link to="/training#courses">All courses <span aria-hidden="true">↗</span></Link>
      </div>
      {loading && !data ? <p className="home-state" role="status">Loading your courses…</p> : null}
      {error ? <div className="home-state" role="status"><p>Unable to load your courses right now.</p><Button variant="secondary" onClick={() => void load()} disabled={loading}>{loading ? "Retrying…" : "Retry courses"}</Button></div> : null}
      {!loading && !error && courses.length === 0 ? <p className="home-state">No courses are assigned yet.</p> : null}
      <div className="home-course-grid">
        {courses.map((course) => <CourseCard key={course.id} presentation="home-preview" summary={course} progress={data?.all_course_progress?.[course.id]} unavailable={Boolean(data?.course_errors?.[course.id])} onRetry={() => void load()} />)}
      </div>
    </section>
  );
};
